"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Ref, Mixins } from "vue-property-decorator";
import PaymentNewVDCardDialog from "@/views/payItems/components/PaymentNewVDCardDialog.vue";
import API from "@ym-framework/api-utils";
import { AccountSessionMixins } from "@/service/account-session";
import { PaymentController } from "@/service/newProdect";
import _ from "lodash";
let PaymentNewWays = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.paymentCards = [];
  }
  getCards() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      if (this._payment_style === "renew") {
        let _ids = [];
        for (let item of this._options.selected.virtualDesktopInfo) {
          if (item.oldId) {
            _ids.push(item.oldId);
          } else if (item.config.oldId) {
            _ids.push(item.config.oldId);
          }
        }
        let response = yield API.post(
          `api://base.auth/api/v7/payment/virtualdesktop/vdcards_options/renew`,
          {
            goods_spec_guid: this._options.selected.goods.id,
            pay_type: "vdcard",
            object_guid_list: _ids
          }
        );
        this.paymentCards = response.data.datas;
      }
      if (this._payment_style === "create") {
        let response = yield API.post(
          `api://base.auth/api/v7/payment/virtualdesktop/vdcards_options`,
          {
            goods_spec_guid: (_a = this._options.selected.goods) == null ? void 0 : _a.id,
            pay_type: "vdcard",
            quantity: this._options.selected.paymentQuantity,
            region_guid: (_b = this._options.selected.categorys) == null ? void 0 : _b.id
          }
        );
        this.paymentCards = response.data.datas;
      }
      if (this._payment_style === "update" || this._payment_style === "recycle") {
        let response = yield API.post(
          `api://base.auth/api/v7/payment/virtualdesktop/vdcards_options/upgrade`,
          {
            goods_spec_guid: (_c = this._options.selected.goods) == null ? void 0 : _c.id,
            pay_type: "vdcard",
            quantity: this._options.selected.paymentQuantity,
            region_guid: (_d = this._options.selected.categorys) == null ? void 0 : _d.id
          }
        );
        this.paymentCards = response.data.datas;
      }
    });
  }
  selectPayment(arr, key) {
    let paymentType = _.find(arr, { payment: key });
    if (paymentType !== void 0) {
      return paymentType;
    } else {
      return false;
    }
  }
  changePaymentType(type) {
    this._options.selected.paymentType = type;
    if (this._options.selected.paymentType !== "vdcard" && this._options.selected.paymentVdcard !== null) {
      this._options.selected.paymentVdcard = null;
    }
    this.discountChange();
  }
  openOptionGiftcards() {
    return __async(this, null, function* () {
      this._options.selected.paymentType = "vdcard";
      yield this.getCards();
      this._VdCardDialog.open();
    });
  }
  discountChange() {
    this.$emit("discountChange");
  }
};
__decorateClass([
  PropSync("options", {
    default: function() {
      return new PaymentController();
    }
  })
], PaymentNewWays.prototype, "_options", 2);
__decorateClass([
  PropSync("paymentStyle", {
    default: function() {
      return "create";
    }
  })
], PaymentNewWays.prototype, "_payment_style", 2);
__decorateClass([
  Ref("vdcard-dialog")
], PaymentNewWays.prototype, "_VdCardDialog", 2);
PaymentNewWays = __decorateClass([
  Component({
    components: {
      PaymentNewVDCardDialog
    }
  })
], PaymentNewWays);
export {
  PaymentNewWays as default
};
